export default __webpack_public_path__ + "static/media/login.5ba4ac77.svg";